import { useState, useEffect } from 'react'
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents
} from 'react-leaflet'
import { encryptLocation } from '../lib/cryptic'
import LocationIcon from '../assets/LocationIcon'

import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'

export const EncryptLocationPage = () => {
  const [encrypted, setEncrypted] = useState(null)
  const [position, setPosition] = useState(null)

  const customIcon = new Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/512/484/484167.png",
    iconSize: [32, 32]
  })

  function LocationMarker() {
    const map = useMapEvents({
      click(event) {
        setPosition(event.latlng)
        map.flyTo(event.latlng, 14)
      },
    })

    if (position) {
      map.flyTo(position, 14)
    }

    return position === null ? null : (
      <Marker position={position} icon={customIcon}>
        <Popup>Encrypted location</Popup>
      </Marker>
    )
  }

  const encryptFormData = (event) => {
    event.preventDefault()

    const formData = new FormData(event.target)
    const lat = parseFloat(formData.get('latitude'))
    const long = parseFloat(formData.get('longitude'))

    if (!isNaN(lat) && !isNaN(long)) {
      const encryptedData = encryptLocation(lat, long)
      setEncrypted(encryptedData)
      setPosition({ lat, lng: long })
    } else {
      alert("Please enter valid latitude and longitude values.")
    }
  }

  // TODO: Add constant tracking in future
  const trackPosition = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords
        setPosition({ lat: latitude, lng: longitude })
        const encryptedData = encryptLocation(latitude, longitude)
        setEncrypted(encryptedData)
      }, (error) => {
        console.error("Error getting location:", error)
        alert("Unable to retrieve your location. Please allow location access.")
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  useEffect(() => {
    if (position && position.lat && position.lng) {
      const encryptedData = encryptLocation(position.lat, position.lng);
      setEncrypted(encryptedData);
    }
  }, [position]);

  return (
    <div className="encrypt-location-page">
      <h3 className="page-title">Encrypt Location</h3>

      <form className="encrypt-form" onSubmit={encryptFormData}>
        <input type="text" name="latitude" placeholder="Latitude" />
        <input type="text" name="longitude" placeholder="Longitude" />

        <button type="button" onClick={trackPosition}>
          <LocationIcon color="#444" />
        </button>

        <button type="submit">Encrypt</button>
      </form>

      <MapContainer
        center={[52.687201, 13.469969]}
        zoom={5}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
        />

        <LocationMarker />
      </MapContainer>

      {encrypted && (
        <div className="result">
          <h6>Encrypted Location:</h6>
          <p>{encrypted.lat} {encrypted.long}</p>
        </div>
      )}
    </div>
  );
}